import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { Observable, of } from 'rxjs';

import { Client, defaultClientInfo } from 'src/app/features/client/models';
import { CancelSigningModalComponent } from 'src/app/features/layout';
import { AudioVideoModalContainerComponent } from 'src/app/features/layout/components/audio-video-modal/audio-video-modal-container.component';
import { ModalsActions, ModalSize } from 'src/app/features/modals';
import { RootStoreState } from 'src/app/store';

import { VideoOptOutReasons } from '../../enums';

@Component({
    selector: 'app-video-device-issues-modal',
    templateUrl: './video-device-issues-modal.component.html',
    styleUrls: ['./video-device-issues-modal.component.scss'],
    standalone: false
})
export class VideoDeviceIssuesModalComponent implements OnInit {
  static identifier = 'VideoDeviceIssuesModalComponent';
  client$: Observable<Client>;
  @Input() hideCancelButton: boolean;
  @Input() isPublishingError: boolean;

  constructor(private readonly store: Store<RootStoreState.State>) {}

  ngOnInit(): void {
    this.client$ = of(defaultClientInfo);
  }

  cancelPackageOnUserRequest() {
    this.store.dispatch(ModalsActions.ClearModalComponent());
    this.store.dispatch(
      ModalsActions.SetStandaloneModalComponent({
        payload: {
          component: CancelSigningModalComponent,
          componentData: {
            fixedCategoryTypeCode: this.isPublishingError
              ? VideoOptOutReasons.PublishingError
              : VideoOptOutReasons.AudioVideoDeviceNotDetected,
          },
        },
      })
    );
  }

  openDeviceSettingsModal() {
    this.store.dispatch(
      ModalsActions.SetStandaloneModalComponent({
        payload: {
          component: AudioVideoModalContainerComponent,
          modalSize: ModalSize.large,
        },
      })
    );
  }

  refresh(): void {
    window.location.reload();
  }
}
